import { RootState, createAppSelector } from "../configureStore";
import type { RequestState } from "../reducers/request";

const stateSelector = (state: RootState) => state.request;

const makeRequestSelector = () =>
    createAppSelector(
        stateSelector,
        (_: RootState, id: string | number) => id,
        (requests: RequestState, id: string | number) => requests[id],
    );

export default makeRequestSelector;
